export default function ($http) {
    return function (pageNumber, filterCriteria) {
        return $http.get('api/vmcaccount', {
            params: {
                pageNumber,
                filter: filterCriteria
            }
        })
        .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/dealer/services/list/getVMCAccountDisplayList.js